import { render } from "./InvoiceCard.vue?vue&type=template&id=123b5e95&scoped=true"
import script from "./InvoiceCard.vue?vue&type=script&lang=ts"
export * from "./InvoiceCard.vue?vue&type=script&lang=ts"

import "./InvoiceCard.vue?vue&type=style&index=0&id=123b5e95&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-123b5e95"

export default script